export { default } from "./Mobile";
